module.exports = __webpack_public_path__ + "static/media/Exodus.651eed2a.png";